module.exports = __webpack_public_path__ + "img/icon-send.11440104.svg";